module.exports = __webpack_public_path__ + "img/telemedecine.b16783d4.jpg";